@if (!isHidden) {
  <div class="trial">
    <div [ngClass]="detailTrialClass" data-cy="pnc-detail-trial">
      @if (isDetailMode) {
        <div class="pnc-detail-trial-title"
        data-cy="pnc-detail-trial-title">{{state?.oldPartNumberData?.title}}</div>
      }
      <div class="{{detailTrialFormGlobalClass}} {{pncTypeCssClass}}"
        data-cy="pnc-create-form-request">
        <div class="grid-table">
          <app-input-autocomplete #oldPartNumberMaterialInput
            (inputStateChange)="manageOldPartNumberMaterialInputStateChange($event)"
            (inputValueChange)="setOldPartNumberMaterialValue($event)"
            [initialValue]="$safeNavigationMigration(state?.oldPartNumberData?.material)"
            [inputFormatter]="typeahead.inputTextNumberDescriptionFormatter"
            [messages]="oldPartNumberMaterialInputMessages"
            [resultFormatter]="typeahead.inputTextNumberDescriptionFormatter"
            [resultsFunction]="searchMaterials"
            [showMessagesWhenDisabled]="true"
            [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.materialInput?.displayMode))"
            [validators]="validators.oldPartNumberMaterial"
            [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.materialInput?.required))"
            baseCypressTag="pnc-form-old-part-number-material"
            label="Old part number/Material"
          placeholder="Select a part number"></app-input-autocomplete>
          <div class="grid-item-second-row">
            @if (state?.showModelCodeDropdown) {
              <app-input-dropdown #modelCodeInputDropdown
                (inputStateChange)="manageModelCodeInputStateChange($event)"
                [showMessagesWhenDisabled]="true"
                (inputValueChange)="setModelCodeValue($event)"
                [initialValue]="plannerValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.modelCodeInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.modelCode), initialValuePipe)"
                [inputFormatter]="typeahead.inputTextFormatter"
                [messages]="modelCodeInputMessages"
                [resultFormatter]="typeahead.inputTextFormatter"
                [resultIsString]="true"
                [resultsFunction]="searchModelCodes"
                [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.modelCodeInput?.displayMode))"
                [validators]="validators.modelCodeDropdown"
                [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.modelCodeInput?.required))"
                baseCypressTag="pnc-form-model-code"
                label="Model code"
                placeholder="Search or select model code">
              </app-input-dropdown>
            } @else {
              <app-input-text #modelCodeInputText
                (inputStateChange)="manageModelCodeInputStateChange($event)"
                [showMessagesWhenDisabled]="true"
                (inputValueChange)="setModelCodeValue($event)"
                [hasSearchIcon]="false"
                [initialValue]="plannerValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.modelCodeInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.modelCode), initialValuePipe)"
                [isToUpperCaseInputTextValue]="true"
                [maxLength]="3"
                [messages]="modelCodeInputMessages"
                [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.modelCodeInput?.displayMode))"
                [validators]="validators.modelCode"
                [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.modelCodeInput?.required))"
                baseCypressTag="pnc-form-model-code"
                label="Model code"
              placeholder="e.g. G20"></app-input-text>
            }
          </div>
          <div class="grid-item-second-row">
            <div class="grid-item-double-input">
              <app-input-text #salesVariantInput
                (inputStateChange)="manageSalesVariantInputStateChange($event)"
                (inputValueChange)="setSalesVariantValue($event)"
                [hasSearchIcon]="false"
                [initialValue]="plannerValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.salesVariantInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.salesVariant), initialValuePipe)"
                [isToUpperCaseInputTextValue]="true"
                [maxLength]="2"
                [messages]="salesVariantInputMessages"
                [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.salesVariantInput?.displayMode))"
                [validators]="validators.salesVariant"
                [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.salesVariantInput?.required))"
                class="grid-item-full-horizontal-space"
                baseCypressTag="pnc-form-sales-variant"
                label="Sales variant"
              placeholder="e.g. A7"></app-input-text>
              <app-input-text #colourInput
                (inputStateChange)="manageColourInputStateChange($event)"
                (inputValueChange)="setColourValue($event)"
                [hasSearchIcon]="false"
                [initialValue]="plannerValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.colourInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.colourCode), initialValuePipe)"
                [isToUpperCaseInputTextValue]="true"
                [maxLength]="4"
                [messages]="colourInputMessages"
                [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.colourInput?.displayMode))"
                [validators]="validators.colour"
                [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.colourInput?.required))"
                class="grid-item-full-horizontal-space"
                baseCypressTag="pnc-form-colour"
                label="Colour"
              placeholder="e.g. WC4L"></app-input-text>
            </div>
          </div>
          <div class="grid-item-second-row">
            @if (!isPartnerMissingPart) {
              <app-input-text #fullLotNumberInput
                (inputStateChange)="manageFullLotNumberInputStateChange($event)"
                (inputValueChange)="setFullLotNumberValue($event)"
                [hasSearchIcon]="false"
                [isToUpperCaseInputTextValue]="true"
                [initialValue]="plannerValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.fullLotNumberInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.fullLotNumber), initialValuePipe)"
                [maxLength]="9"
                [messages]="lotNumberInputMessages"
                [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.fullLotNumberInput?.displayMode))"
                [validators]="validators.fullLotNumber"
                [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.fullLotNumberInput?.required))"
                baseCypressTag="pnc-form-full-lot-number"
                label="Full LOT No."
              placeholder="e.g. E4R5T7896"></app-input-text>
            }
          </div>
        </div>
        @if (!isPartnerMissingPart) {
          <div class="grid-table">
            <app-input-text #quantityInput
              (inputStateChange)="manageQuantityInputStateChange($event)"
              (inputValueChange)="setQuantityValue($event)"
              [hasSearchIcon]="false"
              [initialValue]="initialValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.quantityInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.quantity))"
              [maxLength]="6"
              [messages]="quantityInputMessages"
              [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.quantityInput?.displayMode))"
              [validators]="validators.quantity"
              [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.quantityInput?.required))"
              baseCypressTag="pnc-form-quantity"
              label="Quantity"
            placeholder="e.g. 1"></app-input-text>
          </div>
        } @else {
          <app-pnc-lot-number-input
            (newLotNumbers)="updateLotNumbers($event)"
            [additionalFullLotNumbers]="$safeNavigationMigration(state?.oldPartNumberData?.additionalFullLotNumber)"
            [maxNumberOfAdditional]="$safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.partNumberChangeConfig?.maxNumberOfAdditionalLotNumbers)"
            [isSolvedStatus]="isSolvedStatus"
            [isDetailMode]="isDetailMode"
            [isSolutionAccepted]="isSolutionAccepted"
            [fullLotNumber]="$safeNavigationMigration(state?.oldPartNumberData?.fullLotNumber)"
            [fullLotNumberValidators]="validators.fullLotNumber"
            [isViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.fullLotNumberInput?.displayMode))"
            [quantity]="$safeNavigationMigration(state?.oldPartNumberData?.quantity)"
            [quantityValidators]="validators.quantity">
          </app-pnc-lot-number-input>
        }
        <div class="grid-table">
          <div class="pnc-detail-form-input-large grid-item-horizontal-bigger">
            <app-input-textarea #problemDescriptionInput
              (inputStateChange)="manageDescriptionInputStateChange($event)"
              (inputValueChange)="setProblemDescriptionValue($event)"
              [height]="problemDescriptionHeight"
              [initialValue]="initialValuePipe($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.descriptionInput?.displayMode), $safeNavigationMigration(state?.oldPartNumberData?.problemDescription))"
              [maxLength]="400"
              [messages]="descriptionInputMessages"
              [showViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.descriptionInput?.displayMode))"
              [warningLevel]="warningLevel($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.descriptionInput?.required))"
              baseCypressTag="pnc-form-problem-description"
              label="Problem description"
              placeholder="Write a problem description">
            </app-input-textarea>
          </div>
          @if (showSpoNumber()) {
            <div [ngClass]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.spoNumberInput?.displayMode)) ? 'grid-item view-mode': 'grid-item'">
              <app-part-number-changes-additional-spo-number
                [isDetailMode]="isDetailMode"
                [isInViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.spoNumberInput?.displayMode))"
                [isSolvedStatus]="isSolvedStatus"
                [spoNumber]="spoNumber"
                [pncType]="pncType"
                [isSolutionAccepted]="isSolutionAccepted"
                (newSpoNumberChange)="updateSpoNumbers($event)">
              </app-part-number-changes-additional-spo-number>
            </div>
            <ng-container
              *ngFor="let additionalSpoNumber of this.state?.formData?.additionalSpoNumbers index as index; trackBy: trackByItem">
              <div [ngClass]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.spoNumberInput?.displayMode)) ? 'grid-item view-mode': 'grid-item'">
                <app-part-number-changes-additional-spo-number
                  [additionalIndex]="index + 1"
                  [isDetailMode]="isDetailMode"
                  [isInViewMode]="showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.spoNumberInput?.displayMode))"
                  [isSolvedStatus]="isSolvedStatus"
                  [spoNumber]="additionalSpoNumber"
                  [pncType]="pncType"
                  [isSolutionAccepted]="isSolutionAccepted"
                  (deleteClick)="deleteAdditionalSpoNumber($event)"
                  (newSpoNumberChange)="updateAdditionalSpoNumber($event)">
                </app-part-number-changes-additional-spo-number>
              </div>
            </ng-container>
            @if (!showViewMode($safeNavigationMigration(state?.oldPartNumberDisplayConfiguration?.spoNumberInput?.displayMode))) {
              <div class="grid-item-add-additional-spo-number">
                <app-pnc-add-addition-input-button (addAdditionalInput)="addAdditionalSpoNumber()"
                  [disabled]="!canAddAdditionalSpoNumber()"
                  [tooltipMessage]="additionalSpoNumberTooltipMessage"
                  baseDataCy="pnc-additional-spo-number"
                label="Add additional SPO No."></app-pnc-add-addition-input-button>
              </div>
            }
          }
        </div>
        @if (showSentBy) {
          @if (isDetailMode) {
            <div class="pnc-detail-body-output-field pnc-detail-trial-last-field">
              <div class="pnc-detail-body-output-field-label"
                data-cy="pnc-detail-body-output-field-label-email">Tried by
              </div>
              <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email"
              data-cy="pnc-detail-body-output-field-value-email">{{$safeNavigationMigration(state?.oldPartNumberData?.sentBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
            </div>
          }
        }
      </div>
    </div>
  </div>
  @if (state?.trialRejectionMotivation) {
    <div class="trial-rejection">
      <app-part-number-changes-reject-motivation
        [trialRejectionMotivation]="$safeNavigationMigration(state?.trialRejectionMotivation)">
      </app-part-number-changes-reject-motivation>
    </div>
  }
}
